import T from 'prop-types';
import React from 'react';

function ListItem({ className, thumbnail, name, created, status, action, onClick }) {
  return (
    <div className={`episodes-list__list-item ${className}`} onClick={onClick}>
      <div className="list-item__thumbnail">{thumbnail}</div>
      <div className="list-item__name">{name}</div>
      <div className="list-item__created">{created}</div>
      <div
        className={`list-item__status ${typeof status === 'string' ? status.toLowerCase() : ''}`}
      >
        {status}
      </div>
      <div className="list-item__action">{action}</div>
    </div>
  );
}

ListItem.propTypes = {
  className: T.string,
  thumbnail: T.node,
  name: T.node,
  created: T.node,
  status: T.node,
  onClick: T.func,
};

ListItem.defaultProps = {
  className: '',
};

export default ListItem;
